export const brandsData = [
  {
    name: "Maruti Suzuki",
    subBrands: ["Baleno", "Brezza", "Ciaz", "Vitara Brezza", "Celerio", "Alto"],
  },
  { name: "Hyundai", subBrands: ["i10", "i20", "Creta", "Venue"] },
  { name: "Honda", subBrands: ["City", "Amaze", "Jazz"] },
  { name: "Tata", subBrands: ["Nexon", "Harrier", "Safari", "Tiago"] },
  { name: "Toyota", subBrands: ["Innova", "Fortuner", "Glanza"] },
  { name: "Mahindra", subBrands: ["Scorpio", "XUV500", "Bolero"] },
  { name: "Kia", subBrands: ["Seltos", "Sonet", "Carens"] },
  { name: "Renault", subBrands: ["Kwid", "Duster", "Triber"] },
  { name: "Skoda", subBrands: ["Rapid", "Kushaq", "Slavia"] },
  { name: "Volkswagen", subBrands: ["Polo", "Vento", "Taigun"] },
];

export const years = [
  "2023 & above",
  "2022 & above",
  "2021 & above",
  "2020 & above",
  "2019 & above",
  "2018 & above",
];

export const kmsDriven = [
  {label:"10,000 kms or less", value : "10000"},
  {label:"30,000 kms or less", value : "30000"},
  {label:"50,000 kms or less", value : "50000"},
  {label:"75,000 kms or less", value : "75000"},
  {label:"1,00,000 kms or less", value : "100000"},
  {label:"1,25,000 kms or less", value : "125000"},
];
export const transmissions = [
  { id: "Automatic", name: "Automatic" },
  { id: "Manual", name: "Manual" },
]

export const color = [
  { id: "White", name: "White" },
  { id: "Black", name: "Black" },
  { id: "Silver", name: "Silver" },
  { id: "Red", name: "Red" },
  { id: "Blue", name: "Blue" },
  { id: "Grey", name: "Grey" },
]


  const data =[{
    name: "Transmission",
    models: [
      
    ],
  },
  {
    name: "Model",
    models: [
      { id: "model-1", name: "Sedan" },
      { id: "model-2", name: "SUV" },
      { id: "model-3", name: "Hatchback" },
      { id: "model-4", name: "Coupe" },
      { id: "model-5", name: "Convertible" },
    ],
  },
  {
    name: "Color",
    models: [
      { id: "color-1", name: "White" },
      { id: "color-2", name: "Black" },
      { id: "color-3", name: "Silver" },
      { id: "color-4", name: "Red" },
      { id: "color-5", name: "Blue" },
      { id: "color-6", name: "Grey" },
    ],
  },
];

export const fuels = ["Petrol", "Diesel", "CNG", "Electric"];

export const sortOptions = [
  { label: "Relevance", value: "relevance" },
  { label: "Price: Low to High", value: "priceLow" },
  { label: "Price: High to Low", value: "priceHigh" },
  { label: "KM Driven - Low to High", value: "kmLow" },
  { label: "Year - New to Old", value: "yearNew" },
];
